import request from './request'
import { WORK_TASK_QUERY_URL, WORK_TASK_UPDATE_URL } from './config'

export function queryWorkTask (taskId) {
  return request.post(WORK_TASK_QUERY_URL, { taskId })
}

export function updateWorkTask (payload) {
  return request.post(WORK_TASK_UPDATE_URL, payload || {})
}

